import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
import {Empty, Modal, Select, Spin, Tooltip} from 'antd';
import Swal from "sweetalert2";
import Paging from "../../components/paging";
import { Helmet } from "react-helmet";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";
import { pageNumber } from "../../functions/functionGeneral";
import {APIKEY, BACKEND_API_HOST} from "../../helper/host";
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { clear_auth, set_auth } from "../../reducers/Auth";
import { connect } from "react-redux";
import RefreshIcon from "../../assets/icons/refresh.svg";
import {ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import MapPicker from "react-google-map-picker";
import ImportIcon from "../../assets/icons/import-icon.svg";
import PlusWhiteIcon from "../../assets/icons/plus-white.svg";
import ArrowLeft from "../../assets/icons/arrow-left.svg";
import ArrowRight from "../../assets/icons/arrow-right.svg";
import ReactPaginate from "react-paginate";
import refreshIcon from "../../assets/icons/refresh.svg";
import {TourContext} from "../guideComponent/guideTourProvicer";
import {withTourGuide} from "../guideComponent/withTourGuide";

export class List_outlet extends Component {
    static contextType = TourContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            karyawan: [],
            data: [],
            idDel: '',
            id_outlet: '',
            filter_nama: "",
            radius: "",
            radius_outlet: "",
            pageCount: 0,
            currentPage: 0,
            totalData: 0,
            perPage: 0,
            paging: 20,
            openModal: false,
            guide: false,
            prosesSimpan: false,
            modalAdd: false,
            modalEdit: false,
            modalimport: false,
            importFile: null,
            isLoading       : true,
            nama_outlet     : '',
            email_outlet    : '',
            no_hp_outlet    : '',
            alamat          : '',
            nama_pemilik    : '',
            location        : {
                lat: -7.865242,
                lng: 110.156070
            },
            lokasi_karyawan: [],

        }
        this.handleChange = this.handleChange.bind(this)
        this.handleFilter = this.handleFilter.bind(this)
        this.resetFilter = this.resetFilter.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
        this.wantDelete = this.wantDelete.bind(this)
        this.importExcel = this.importExcel.bind(this)
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    disableBody = target => disableBodyScroll(target)
    enableBody = target => enableBodyScroll(target)

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handlePageClick(data) {
        let selected = data.selected; // zero based index
        this.setState({ currentPage: selected, data: [], loading: true }, () => {
            this.loadData();
        });
    }

    handleOk = e => {
        this.setState({
            modalexport: false,
            modalimport: false,
            modal: false
        });
    };

    handleCancel = e => {
        this.setState({
            modalexport: false,
            modalimport: false,
            modal: false

        });
    };

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    handleFilter(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,

            data: [],
            loading: true
        }, () => this.loadData())
    }

    resetFilter(event) {
        this.setState({
            filter_nama: '',
            data: [],
            loading: true
        }, () => this.loadData())
    }

    wantDelete() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus Lokasi Kunjungan?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        id: this.state.idDel
                    }
                    this.setState({
                        loading: true,
                        data: [],
                    })
                    this.props.request("outlet/delete", form, 'POST')
                        .then(response => {
                            if (response && response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.loadData()
                            }
                        });
                }
            })
    }

    loadData() {
        let form = {
            paginate: 10,
            page: this.state.currentPage + 1,
            filter_nama: this.state.filter_nama
        }
        this.props.request("outlet/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data.data,
                        radius_outlet: response.perusahaan_radius_outlet,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                        loading: false
                    })
                }
            });
    }

    lokasiKaryawanHandler = () => {
        if (this.state.lokasi_karyawan === 'all') {
            this.setState({
                lokasi_karyawan: []
            })
        } else {
            this.setState({
                lokasi_karyawan: 'all'
            })
        }
    }

    tambahOutlet = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            nama            : this.state.nama_outlet,
            email           : this.state.email_outlet,
            no              : this.state.no_hp_outlet,
            latitude        : this.state.location.lat,
            longtitude      : this.state.location.lng,
            alamat          : this.state.alamat,
            nama_pemilik    : this.state.nama_pemilik,
            radius          : this.state.radius,
            karyawan        : this.state.lokasi_karyawan,
        }

        this.props.request("outlet/add", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.loadData()
                    this.setState({
                        modalAdd        : false,
                        loading         : false,
                        radius          : 0,
                        nama_outlet     : '',
                        email_outlet    : '',
                        no_hp_outlet    : '',
                        alamat          : '',
                        nama_pemilik    : '',
                        location        : {
                            lat: -7.865242,
                            lng: 110.156070
                        },
                        lokasi_karyawan : []
                    })
                    Swal.fire({
                        title               : 'Berhasil!',
                        text                : response.message,
                        icon                : 'success',
                        showConfirmButton   : false,
                        timer               : 800,
                    })
                }else if (response) {
                    Swal.fire({
                        title               : 'Gagal!',
                        text                : response.message,
                        icon                : 'warning',
                        showConfirmButton   : false,
                        timer               : 800,
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    loadKaryawan(){
        let form = {}
        this.props.request("karyawan/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        karyawan: response.data,
                        loading         : false
                    })
                }
            });
    }

    exportLokasiKunjungan = () => {
        var AuthKey = localStorage.getItem('Presensi-Auth-Key')
        window.open(BACKEND_API_HOST + 'outlet/export_template?token=' + AuthKey, "_blank")
    }

    importExcel() {
        this.setState({
            importLoading: true
        })

        var AuthKey = localStorage.getItem('Presensi-Auth-Key')

        let formData = new FormData()
        formData.append('file', this.state.importFile)
        formData.append('token', AuthKey)

        fetch(BACKEND_API_HOST + 'outlet/import', {
            method: 'POST',
            headers: {
                'Authorization': 'bearer ' + AuthKey
            },
            body: formData
        })
            .catch((error) => {
                console.error(error);
            })
            .then((response) => response.json())
            .then((response) => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1200,
                    })
                    window.location.reload();
                    this.setState({
                        modalimport: false,
                        loading: true,
                        importFile: null,
                        data: [],
                    }, () => {
                        this.loadData()
                    })
                }
                else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        showConfirmButton: false,
                        timer: 1200,
                    })
                    this.setState({
                        modalimport: false,
                    })
                }

                this.setState({ importLoading: false })
            })
    }

    outletDetail(){
        let form = {
            id: this.state.id_outlet
        }
        this.props.request("outlet/detail", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    const data = response.data
                    this.setState({
                        nama_outlet     : data.outlet_nama,
                        email_outlet    : data.outlet_email,
                        no_hp_outlet    : data.outlet_no_hp,
                        radius          : data.outlet_radius,
                        location        : {
                            lat : data.outlet_latitude,
                            lng : data.outlet_longitude,
                        },
                        lokasi_karyawan : data.karyawan ? data.karyawan.map(function (item) {
                            return item.perusahaan_id === data.perusahaan_id ? parseInt(item.karyawan_id) : item.karyawan_nama;
                        }) : null,
                        loading         : false,
                        modalEdit       : true
                    })
                }
            });
    }

    simpanOutlet = () => {
        this.setState({
            modalEdit    : false,
            prosesSimpan : true,
        })

        let form = {
            id          : this.state.id_outlet,
            nama        : this.state.nama_outlet,
            email       : this.state.email_outlet,
            no          : this.state.no_hp_outlet,
            latitude    : this.state.location.lat,
            longtitude  : this.state.location.lng,
            radius      : this.state.radius,
            karyawan    : this.state.lokasi_karyawan,
        }

        this.props.request("outlet/edit", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.setState({
                        data: [],
                        nama_outlet     : '',
                        email_outlet    : '',
                        no_hp_outlet    : '',
                        alamat          : '',
                        nama_pemilik    : '',
                        radius          : 100,
                        location        : {
                            lat: -7.865242,
                            lng: 110.156070
                        },
                        lokasi_karyawan : []
                    }, () => {
                        this.loadData()
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    componentDidMount() {
        this.loadData()
        this.loadKaryawan()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.fltr-nama',
                        title: 'Cari Lokasi Kunjungan',
                        content: 'Gunakan kolom pencarian ini untuk menemukan lokasi kunjungan berdasarkan nama lokasi.',
                    },
                    {
                        selector: '.button-reset',
                        title: 'Reset Pencarian',
                        content: 'Klik tombol ini untuk menghapus pencarian dan menampilkan kembali seluruh data lokasi kunjungan.',
                    },
                    {
                        selector: '.izin-btn-w100',
                        title: 'Tambah Lokasi',
                        content: 'Klik tombol ini untuk menambahkan lokasi kunjungan baru.',
                    },
                ];

                if (this.state.data.length === 0) {
                    tourSteps.push({
                        selector: '.table-lokasi',
                        title: 'Daftar Lokasi Kunjungan (Kosong)',
                        content: 'Belum ada data lokasi kunjungan yang tersedia. Gunakan tombol "Tambah Lokasi" untuk membuat lokasi baru.',
                    });
                } else {
                    tourSteps.push(
                        {
                            selector: '.table-lokasi',
                            title: 'Daftar Lokasi Kunjungan',
                            content: `Tabel ini menampilkan ${this.state.data.length} lokasi kunjungan yang terdaftar dalam sistem.`,
                        },
                        {
                            selector: '.aksi-lokasi',
                            title: 'Aksi',
                            content: 'Gunakan menu aksi untuk mengelola data lokasi seperti melihat detail, mengubah data, atau menghapus lokasi.',
                        }
                    );
                }

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        let no = 0;
        const { Option } = Select;
        const style = {
            filter_nama: {
                backgroundColor: "#F9F9F9",
                padding: "12px 10px",
                color: "#5D6F80",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "16px"
            },
            th_style: {
                borderBottom: "0px",
                padding: "16px 12px",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252B2B",
            },
            td_style: {
                padding: "16px 12px",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252B2B"
            }
        }
        const style_add = {
            modal_header: {
                backgroundColor: "#FAFDFF",
                padding: "12px",
            },
            title_header: {
                color: "#143B5E",
                fontSize: "24px",
                fontWeight: 700,
                lineHeight: "36px"
            },
            label_input: {
                color: "#143B5E",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px"
            },
            input_group_text: {
                backgroundColor: "#EFEFEF",
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: 500,
                padding: "12px"
            },
            input: {
                backgroundColor: "#FFFFFF",
                border: "1px solid #DDDDDD",
                borderRadius: "4px",
                padding: "12px",
                fontSize: "12px",
                lineHeight: "18px",
                fontWeight: 400
            },
            select: {
                backgroundColor: "#FFFFFF",
                border: "1px solid #DDDDDD",
                borderRadius: "4px",
                padding: "12px",
                minHeight: "44px",
                fontSize: "12px",
                lineHeight: "18px",
                fontWeight: 400
            },
            hari: {
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "24px",
                color: "#252B2",
                textAlign: "left",
                margin: "0px"
            },
        }
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Daftar Lokasi Kunjungan - Presensi</title>
                    <meta name="description" content="Daftar Lokasi Kunjungan" />
                </Helmet>
                    <Breadcrumb title="Daftar Lokasi Kunjungan" parent="Lokasi Kunjungan" setGuide={() => { this.setState({ guide: true }) }} />
                    <Tour isOpen={this.state.guide === true} onAfterOpen={this.disableBody} onBeforeClose={this.enableBody} onRequestClose={() => this.setState({ guide: false })} />
                    <Modal visible={this.state.modalAdd} bodyStyle={{ maxWidth: "1000px", padding: 0, borderRadius: "8px" }} width={1000}
                           closeIcon={<></>}
                           footer={null}
                           onCancel={() => this.setState({
                               modalAdd       : false,
                               nama_outlet    : '',
                               email_outlet   : '',
                               no_hp_outlet   : '',
                               alamat         : '',
                               nama_pemilik   : '',
                               radius         : 100,
                               location       : {
                                   lat: -7.865242,
                                   lng: 110.156070
                               },
                               lokasi_karyawan: []
                           })}>
                        <ModalHeader style={style_add.modal_header} className="borderRadiusHeader" toggle={() => this.setState({
                            modalAdd       : false,
                            nama_outlet    : '',
                            email_outlet   : '',
                            no_hp_outlet   : '',
                            alamat         : '',
                            nama_pemilik   : '',
                            radius         : 100,
                            location       : {
                                lat: -7.865242,
                                lng: 110.156070
                            },
                            lokasi_karyawan: []
                        })}><div style={style_add.title_header}>Tambah Lokasi Kunjungan</div></ModalHeader>
                        <ModalBody className='p-4'>
                            <div className='row mb-2'>
                                <div className='col-md-12'
                                     onPointerEnter={(e) => {
                                         this.triggerGuideOnce(e, {
                                             key: "mapLokasiAdd",
                                             title: "Peta Lokasi",
                                             content: "Gunakan peta ini untuk menentukan titik lokasi kunjungan. Pin dapat digeser untuk menyesuaikan posisi yang diinginkan."
                                         });
                                     }}
                                >
                                    <MapPicker
                                        key={Math.random}
                                        style={{ position: 'relative', width: '100%', height: '387px' }}
                                        name='location'
                                        defaultLocation={this.state.location}
                                        zoom={10}
                                        onChangeLocation={(lat, lng) => {
                                            this.setState({
                                                location: {
                                                    lat: lat,
                                                    lng: lng
                                                }
                                            })
                                        }}
                                        apiKey={APIKEY} />
                                </div>
                            </div>
                            <div className='row mb-4'>
                                <div className='col-md-4'></div>
                                <div className='col-md-4'>
                                    <div className='input-group'>
                                        <div className='input-group-append'>
                                            <span className='input-group-field br-left-4'><small>Latitude</small></span>
                                        </div>
                                        <input
                                            className='form-control input-custom'
                                            value={this.state.location.lat}
                                            type='number'
                                            onChange={(event) => {
                                                const target = event.target;
                                                const value = target.value;
                                                this.setState({
                                                    location: {
                                                        lat: parseFloat(value),
                                                        lng: this.state.location.lng
                                                    }
                                                })
                                            }}
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "latitudeAdd",
                                                    title: "Latitude",
                                                    content: "Menampilkan koordinat latitude dari titik lokasi yang dipilih pada peta."
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='input-group'>
                                        <div className='input-group-append'>
                                            <span
                                                className='input-group-field br-left-4'><small>Longitude</small></span>
                                        </div>
                                        <input
                                            className='form-control input-custom'
                                            value={this.state.location.lng}
                                            type='number'
                                            onChange={(event) => {
                                                const target = event.target;
                                                const value = target.value;
                                                this.setState({
                                                    location: {
                                                        lat: this.state.location.lat,
                                                        lng: parseFloat(value)
                                                    }
                                                })
                                            }}
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "longitudeAdd",
                                                    title: "Longitude",
                                                    content: "Menampilkan koordinat longitude dari titik lokasi yang dipilih pada peta."
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <div className='row'>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>Nama Lokasi Kunjungan</label>
                                    <input className='form-control' type='text' name='nama_outlet'
                                           onChange={(e) => this.handleChange(e)} value={this.state.nama_outlet}
                                           style={style_add.input} placeholder='Ketik lokasi kunjungan disini'
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "namaLokasiAdd",
                                                   title: "Nama Lokasi Kunjungan",
                                                   content: "Masukkan nama lokasi kunjungan yang akan didaftarkan."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>Nama Pemilik</label>
                                    <input className='form-control' type='text' name='nama_pemilik'
                                           onChange={(e) => this.handleChange(e)} value={this.state.nama_pemilik}
                                           style={style_add.input} placeholder='Ketik nama pemilik disini'
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "namaPemilikAdd",
                                                   title: "Nama Pemilik",
                                                   content: "Masukkan nama pemilik atau penanggung jawab lokasi."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>Email Lokasi Kunjungan</label>
                                    <input type="text" name="email_outlet" className="form-control"
                                           value={this.state.email_outlet} placeholder="Email Lokasi Kunjungan..."
                                           style={style_add.input} onChange={this.handleChange}
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "emailLokasiAdd",
                                                   title: "Email Lokasi Kunjungan",
                                                   content: "Masukkan alamat email yang terkait dengan lokasi kunjungan."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>No. Telepon Lokasi Kunjungan</label>
                                    <input className='form-control' type='text' name='no_hp_outlet'
                                           onChange={(e) => this.handleChange(e)} value={this.state.no_hp_outlet}
                                           style={style_add.input} placeholder='Ketik nomor telepon disini'
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "teleponLokasiAdd",
                                                   title: "No. Telepon Lokasi",
                                                   content: "Masukkan nomor telepon yang dapat dihubungi untuk lokasi ini."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-8'>
                                    <label className='form-label' style={style_add.label_input}>Alamat</label>
                                    <textarea className='form-control' name='alamat'
                                              onChange={(e) => this.handleChange(e)} value={this.state.alamat}
                                              style={{
                                                  backgroundColor: "#FFFFFF",
                                                  border: "1px solid #DDDDDD",
                                                  borderRadius: "4px",
                                                  paddingTop: "3px",
                                                  paddingBottom: "3px",
                                                  paddingLeft: "5px",
                                                  paddingRight: "5px",
                                                  fontSize: "12px",
                                                  lineHeight: "18px",
                                                  fontWeight: 400
                                              }} placeholder='Ketik alamat disini'
                                              onPointerEnter={(e) => {
                                                  this.triggerGuideOnce(e, {
                                                      key: "alamatLokasiAdd",
                                                      title: "Alamat",
                                                      content: "Masukkan alamat lengkap dari lokasi kunjungan."
                                                  });
                                              }}
                                    />
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-md-4'>
                                    <label className='form-label'
                                           style={{
                                               color: "#143B5E",
                                               fontWeight: 500,
                                               fontSize: "14px"
                                           }}>Radius Kunjungan
                                    </label>
                                    <div className='input-group'>
                                        <input className='form-control' value={this.state.radius} type='number'
                                               onChange={(e) => this.handleChange(e)} name='radius'
                                               style={style_add.input}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "radiusKunjunganAdd",
                                                       title: "Radius Kunjungan",
                                                       content: "Tentukan radius area kunjungan dalam meter yang digunakan sebagai batas lokasi."
                                                   });
                                               }}
                                        />
                                        <div className='input-group-append'>
                                            <span className='input-group-text'
                                                  style={style_add.input_group_text}>Meter</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="form-group"
                                         onPointerEnter={(e) => {
                                             this.triggerGuideOnce(e, {
                                                 key: "karyawanLokasiAdd",
                                                 title: "Karyawan",
                                                 content: "Pilih karyawan yang dapat melakukan kunjungan ke lokasi ini."
                                             });
                                         }}
                                    >
                                        <label className='form-label'
                                               style={{
                                                   color: "#143B5E",
                                                   fontWeight: 500,
                                                   fontSize: "14px"
                                               }}>Karyawan
                                        </label>
                                        {this.state.lokasi_karyawan !== 'all' ?
                                            <Select name="select_karyawan"
                                                    className={"col-xl-12 col-md-12"}
                                                    mode={"multiple"}
                                                    placeholder="Pilih Karyawan"
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(event) => {
                                                        this.setState({
                                                            lokasi_karyawan: event
                                                        })
                                                    }}>
                                                {this.state.karyawan.map((item, index) => {
                                                    return (
                                                        <Option key={item.karyawan_id}>{item.karyawan_nama}</Option>)
                                                })}
                                            </Select> : null
                                        }
                                        <label style={{fontSize: "12px"}}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "semuaKaryawanLokasiAdd",
                                                       title: "Semua Karyawan",
                                                       content: "Centang opsi ini jika semua karyawan diizinkan melakukan kunjungan ke lokasi ini."
                                                   });
                                               }}
                                        >
                                            <input style={{fontSize: "16px", borderRadius: "8px"}}
                                                   type="checkbox"
                                                   checked={this.state.lokasi_karyawan === 'all'}
                                                   onChange={() => this.lokasiKaryawanHandler()}/>
                                            &nbsp;Semua Karyawan
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter style={{
                            backgroundColor: "#F9F9F9",
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px"
                        }} className='px-4 py-3'>
                        <button className='btn text-capitalize batalkan-add-jamker' onClick={() => this.setState({
                                modalAdd       : false,
                                nama_outlet    : '',
                                email_outlet   : '',
                                no_hp_outlet   : '',
                                alamat         : '',
                                nama_pemilik   : '',
                                radius         : 100,
                                location       : {
                                    lat: -7.865242,
                                    lng: 110.156070
                                },
                                lokasi_karyawan: []
                            })}>Batalkan
                            </button>
                            <button className='btn btn-primary text-capitalize' onClick={() => this.tambahOutlet()}
                                    disabled={this.state.prosesSimpan} style={{
                                padding: "8px 14px",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "24px"
                            }}>Tambahkan Lokasi
                            </button>
                        </ModalFooter>
                    </Modal>
                    <Modal visible={this.state.modalEdit} bodyStyle={{maxWidth: "1000px", padding: 0}} width={1000}
                           closeIcon={<></>}
                           footer={null}
                           onCancel={() => this.setState({
                               modalEdit: false,
                               nama_outlet: '',
                               email_outlet: '',
                               no_hp_outlet: '',
                               alamat: '',
                               nama_pemilik: '',
                               radius: 100,
                               location: {
                                   lat: -7.865242,
                                   lng: 110.156070
                               },
                               lokasi_karyawan: []
                           })}>
                        <ModalHeader style={style_add.modal_header} toggle={() => this.setState({
                            modalEdit       : false,
                            nama_outlet     : '',
                            email_outlet    : '',
                            no_hp_outlet    : '',
                            alamat          : '',
                            nama_pemilik    : '',
                            radius          : 100,
                            location        : {
                                lat: -7.865242,
                                lng: 110.156070
                            },
                            lokasi_karyawan : []
                        })}><div style={style_add.title_header}>Edit Lokasi Kunjungan</div></ModalHeader>
                        <ModalBody className='p-4'>
                            <div className='row mb-2'>
                                <div className='col-md-12'
                                     onPointerEnter={(e) => {
                                         this.triggerGuideOnce(e, {
                                             key: "mapLokasiEdit",
                                             title: "Peta Lokasi",
                                             content: "Gunakan peta ini untuk menentukan titik lokasi kunjungan. Pin dapat digeser untuk menyesuaikan posisi lokasi."
                                         });
                                     }}
                                >
                                    <MapPicker
                                        style={{ position: 'relative', width: '100%', height: '250px' }}
                                        name='location'
                                        defaultLocation={this.state.location}
                                        zoom={10}
                                        onChangeLocation={(lat, lng) => {
                                            this.setState({
                                                location: {
                                                    lat: lat,
                                                    lng: lng
                                                }
                                            })
                                        }}
                                        apiKey={APIKEY} />
                                </div>
                            </div>
                            <div className='row mb-4'>
                                <div className='col-md-4'></div>
                                <div className='col-md-4'>
                                    <div className='input-group'>
                                        <div className='input-group-append'>
                                            <span className='input-group-field br-left-4'><small>Latitude</small></span>
                                        </div>
                                        <input
                                            className='form-control input-custom'
                                            value={this.state.location.lat}
                                            type='number'
                                            onChange={(event) => {
                                                const target = event.target;
                                                const value = target.value;
                                                this.setState({
                                                    location: {
                                                        lat: parseFloat(value),
                                                        lng: this.state.location.lng
                                                    }
                                                })
                                            }}
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "latitudeEdit",
                                                    title: "Latitude",
                                                    content: "Menampilkan koordinat latitude dari titik lokasi yang dipilih pada peta."
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='input-group'>
                                        <div className='input-group-append'>
                                            <span className='input-group-field br-left-4'><small>Longitude</small></span>
                                        </div>
                                        <input
                                            className='form-control input-custom'
                                            value={this.state.location.lng}
                                            type='number'
                                            onChange={(event) => {
                                                const target = event.target;
                                                const value = target.value;
                                                this.setState({
                                                    location: {
                                                        lat: this.state.location.lat,
                                                        lng: parseFloat(value)
                                                    }
                                                })
                                            }}
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "longitudeEdit",
                                                    title: "Longitude",
                                                    content: "Menampilkan koordinat longitude dari titik lokasi yang dipilih pada peta."
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <div className='row mb-2'>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>Nama Lokasi Kunjungan</label>
                                    <input className='form-control' type='text' name='nama_outlet' onChange={(e) => this.handleChange(e)} value={this.state.nama_outlet} style={style_add.input} placeholder='Masukkan nama lokasi kunjungan'
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "namaLokasiEdit",
                                                   title: "Nama Lokasi Kunjungan",
                                                   content: "Masukkan nama lokasi kunjungan yang akan didaftarkan."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>Email Lokasi Kunjungan</label>
                                    <input className='form-control' type='text' name='email_outlet'
                                           onChange={(e) => this.handleChange(e)} value={this.state.email_outlet}
                                           style={style_add.input} placeholder='Masukkan email lokasi kunjungan'
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "emailLokasiEdit",
                                                   title: "Email Lokasi Kunjungan",
                                                   content: "Masukkan alamat email yang terkait dengan lokasi kunjungan."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>No HP. Lokasi Kunjungan</label>
                                    <input className='form-control' type='text' name='no_hp_outlet'
                                           onChange={(e) => this.handleChange(e)} value={this.state.no_hp_outlet}
                                           style={style_add.input} placeholder='Masukkan email lokasi kunjungan'
                                           onPointerEnter={(e) => {
                                               this.triggerGuideOnce(e, {
                                                   key: "teleponLokasiEdit",
                                                   title: "No. Telepon Lokasi",
                                                   content: "Masukkan nomor telepon yang dapat dihubungi untuk lokasi ini."
                                               });
                                           }}
                                    />
                                </div>
                                <div className='col-md-4 mb-2'>
                                    <label className='form-label' style={style_add.label_input}>Radius Kunjungan</label>
                                    <div className='input-group'>
                                        <input className='form-control' value={this.state.radius} type='number'
                                               onChange={(e) => this.handleChange(e)} name='radius'
                                               style={style_add.input}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "radiusKunjunganEdit",
                                                       title: "Radius Kunjungan",
                                                       content: "Tentukan radius area kunjungan dalam meter yang digunakan sebagai batas lokasi."
                                                   });
                                               }}
                                        />
                                        <div className='input-group-append'>
                                            <span className='input-group-text'
                                                  style={style_add.input_group_text}>Meter</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-8'
                                     onPointerEnter={(e) => {
                                         this.triggerGuideOnce(e, {
                                             key: "karyawanLokasiEdit",
                                             title: "Karyawan",
                                             content: "Pilih karyawan yang dapat melakukan kunjungan ke lokasi ini."
                                         });
                                     }}
                                >
                                    <label className='form-label' style={style_add.label_input}>Karyawan</label>
                                    <div className="col-xl-12 col-md-12 p-0">
                                        {this.state.lokasi_karyawan !== 'all' ?
                                            <Select name="select_karyawan"
                                                    style={{width: '100%'}}
                                                    mode={"multiple"}
                                                    placeholder="Pilih Karyawan"
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    value={this.state.lokasi_karyawan}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            lokasi_karyawan: event
                                                        })
                                                    }}>
                                                {this.state.karyawan.map((item, index) => {
                                                    return (<Option value={item.karyawan_id} key={item.karyawan_id}>
                                                        {item.karyawan_nama}
                                                    </Option>)
                                                })}
                                            </Select> : null
                                        }
                                        <label style={{fontSize: "12px"}}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "semuaKaryawanLokasiEdit",
                                                       title: "Semua Karyawan",
                                                       content: "Centang opsi ini jika semua karyawan diizinkan melakukan kunjungan ke lokasi ini."
                                                   });
                                               }}
                                        >
                                            <input style={{fontSize: "12px"}} type="checkbox"
                                                   checked={this.state.lokasi_karyawan === 'all'}
                                                   onChange={() => this.lokasiKaryawanHandler()}/>
                                            &nbsp;Semua Karyawan
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter style={{
                            backgroundColor: "#F9F9F9",
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px"
                        }} className='px-4 py-3'>
                            <button className='btn text-capitalize batalkan-add-jamker' onClick={() => this.setState({
                                modalEdit       : false,
                                nama_outlet     : '',
                                email_outlet    : '',
                                no_hp_outlet    : '',
                                alamat          : '',
                                nama_pemilik    : '',
                                radius          : 100,
                                location        : {
                                    lat: -7.865242,
                                    lng: 110.156070
                                },
                                lokasi_karyawan : []
                            })}>Batalkan
                            </button>
                            <button
                                className='btn btn-primary text-capitalize'
                                disabled={this.state.loading}
                                onClick={() => this.simpanOutlet()}
                                style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
                            >
                                Edit Lokasi
                            </button>
                        </ModalFooter>
                    </Modal>
                    <Modal
                        title="Import Lokasi Kunjungan"
                        visible={this.state.modalimport}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        footer={[
                            this.state.importLoading ?
                                <button className={'btn btn-primary'} style={{textTransform: "none", width: "100%"}}
                                        disabled={true}><i className="fa fa-refresh fa-spin"></i> Sedang mengupload data
                                </button>
                                :
                                <button className={this.state.importFile === null ? 'btn bg-secondary-custom' : 'btn btn-primary'} style={{ textTransform: "none", width: "100%" }} disabled={this.state.importFile === null} onClick={this.importExcel}>Import Data</button>
                        ]}
                    >
                        <div>
                            <a style={{ color: "#5D6F80", cursor: "default" }}>Anda bisa mengunduh template yang sudah kami sediakan untuk mempermudah pengimportan.</a><br />
                            <a onClick={this.exportLokasiKunjungan} style={{ color: "#057CE4" }}>Unduh template disini</a>
                            <div style={{ position: 'relative', width: '100%', backgroundColor: '#F9F9F9', padding: 16, borderRadius: 6, marginTop: 8, border: "1px dashed #DDDDDD" }}>
                                <input type='file'
                                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                       onChange={(event) => {
                                           this.setState({
                                               importFile: event.target.files[0],
                                           })
                                       }} /><br />
                            </div>
                        </div>
                    </Modal>
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header pb-0 px-3 mb-3" style={{borderBottom: 'none'}}>
                                <div className="row mx-0" style={{marginLeft: '5px'}}>
                                    <div className="col-md-5 d-flex flex-row flex-nowrap mb-2">
                                        <input name="filter_nama"
                                               className="form-control fltr-nama mr-2"
                                               placeholder="&#xF002;  Cari nama kunjungan ..."
                                               type="text"
                                               required=""
                                               value={this.state.filter_nama}
                                               onChange={this.handleChange}
                                               onKeyUp={(event) => {
                                                   event.preventDefault()
                                                   if (event.which == 13) {
                                                       this.setState({
                                                           page: 0,
                                                           paging: this.state.paging,
                                                           loading: true
                                                       }, () => {
                                                           this.loadData()
                                                       });
                                                   }
                                               }}
                                        />
                                        <div>
                                            <button className="input-select-style button-reset mt-0" style={{width: "44px"}} onClick={this.resetFilter}>
                                                <img src={refreshIcon} alt=""/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) && (
                                            <>
                                                <button
                                                    className='btn btn-primary text-capitalize float-right izin-btn-w100'
                                                    style={{lineHeight: "24px"}} onClick={() => {
                                                    this.setState({
                                                        modalAdd: true,
                                                        radius: 100,
                                                        location: {
                                                            lat: -7.865242,
                                                            lng: 110.156070
                                                        },
                                                    })
                                                }}><img className='mr-2' alt='' src={PlusWhiteIcon}/>
                                                    Tambah Lokasi
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body daftar-absen">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            {!this.state.loading && this.state.data.length === 0 ?
                                                <span className='table-lokasi'>
                                                    <Empty description="Data Kosong"
                                                           image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"/>
                                                </span>
                                                :
                                                (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && (
                                                    <table className="table table-striped table-borderless mb-5 table-lokasi">
                                                        <thead>
                                                        <tr>
                                                            <th style={{
                                                                borderBottom: "0px",
                                                                padding: "16px 12px",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#252B2B",
                                                                width: "30px"
                                                            }}>#
                                                            </th>
                                                            <th style={{
                                                                borderBottom: "0px",
                                                                padding: "16px 12px",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#252B2B",
                                                                minWidth: "250px",
                                                                maxWidth: "447px"
                                                            }}>Lokasi Kunjungan</th>
                                                            <th style={{
                                                                borderBottom: "0px",
                                                                padding: "16px 12px",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#252B2B",
                                                                minWidth: "170px",
                                                                maxWidth: "447px"
                                                            }} className="text-center">Email</th>
                                                            <th style={{
                                                                borderBottom: "0px",
                                                                padding: "16px 12px",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#252B2B",
                                                                minWidth: "160px",
                                                                maxWidth: "447px"
                                                            }} className="text-center">Nama Pemilik
                                                            </th>
                                                            <th style={{
                                                                borderBottom: "0px",
                                                                padding: "16px 12px",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#252B2B",
                                                                minWidth: "250px",
                                                                maxWidth: "447px"
                                                            }} className="text-center">Alamat
                                                            </th>
                                                            <th style={style.th_style} className="text-center">No.
                                                                Telepon
                                                            </th>
                                                            <th style={{
                                                                borderBottom: "0px",
                                                                padding: "16px 12px",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "24px",
                                                                color: "#252B2B",
                                                                minWidth: "200px",
                                                                maxWidth: "447px"
                                                            }} className="text-center">Karyawan
                                                            </th>
                                                            <th style={style.th_style}>Aksi</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.loading &&
                                                            <Tr>
                                                                <Td colSpan={9}>
                                                                    <Spin size="large" tip="Loading..." style={{
                                                                        width: '100%',
                                                                        margin: 'auto',
                                                                        marginBottom: '10px',
                                                                        marginTop: '10px'
                                                                    }}/>
                                                                </Td>
                                                            </Tr>
                                                        }
                                                        {this.state.data.map((item) => {
                                                            no += 1
                                                            return (
                                                                <tr>
                                                                    <td style={style.td_style} align="center">{pageNumber(no, this.state.perPage, this.state.currentPage)}</td>
                                                                    <td style={style.td_style}>{item.outlet_nama}</td>
                                                                    <td style={style.td_style} align="center">{item.outlet_email !== null ? item.outlet_email : '-'}</td>
                                                                    <td style={style.td_style} align="center">{item.outlet_nama_pemilik !== null ? item.outlet_nama_pemilik : '-'}</td>
                                                                    <td style={style.td_style} align="center">{item.outlet_alamat !== null ? item.outlet_alamat : '-'}</td>
                                                                    <td style={style.td_style} align="center">{item.outlet_no_hp !== null ? item.outlet_no_hp : '-'}</td>
                                                                    <td style={style.td_style} align="center">{item.karyawan.length} Karyawan</td>
                                                                    <td style={style.td_style} align="center">
                                                                        <Tooltip trigger={'click'} className='aksi-lokasi' placement="bottom"
                                                                                 color={'#fff'} title={
                                                                            <div className={'p-2'}>
                                                                                <a onClick={() => {
                                                                                    this.setState({
                                                                                        modal: item.outlet_id
                                                                                    })
                                                                                }} className={'text-dark'}>Lihat
                                                                                    Lokasi</a><br/>
                                                                                {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) && (
                                                                                    <>
                                                                                        <a
                                                                                            onClick={() => this.setState({
                                                                                                id_outlet: item.outlet_id
                                                                                            }, () => this.outletDetail())}
                                                                                            className={'text-dark'}>Edit
                                                                                        </a>
                                                                                        <br/>
                                                                                    </>
                                                                                )}
                                                                                {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("D") >= 0) && (
                                                                                    <a onClick={() => {
                                                                                        this.setState({
                                                                                            idDel: item.outlet_id
                                                                                        })
                                                                                        this.wantDelete()
                                                                                    }}
                                                                                       className={'text-danger'}>Hapus</a>
                                                                                )}
                                                                            </div>
                                                                        }>
                                                                            <a><i
                                                                                className="fa fa-ellipsis-v" style={{
                                                                                width: 35,
                                                                                fontSize: 18,
                                                                                padding: 11,
                                                                                color: 'rgb(51 51 51)'
                                                                            }}
                                                                            ></i></a>
                                                                        </Tooltip>
                                                                        <Modal
                                                                            visible={this.state.modal == item.outlet_id}
                                                                            onOk={this.handleOk}
                                                                            onCancel={this.handleCancel}
                                                                        >
                                                                            <div style={{
                                                                                position: 'relative',
                                                                                width: '100%',
                                                                                height: '250px'
                                                                            }}>
                                                                                <Map
                                                                                    google={this.props.google}
                                                                                    initialCenter={{
                                                                                        lat: item.outlet_latitude,
                                                                                        lng: item.outlet_longitude
                                                                                    }}
                                                                                    zoom={15}>
                                                                                    <Marker/>
                                                                                </Map>
                                                                            </div>
                                                                        </Modal>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                        </tbody>
                                                    </table>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card-footer p-0'>
                                <div className='row mx-0' style={{backgroundColor: "#F5F5F5", width: "100%"}}>
                                    {/* {this.state.data.length !== 0 && */}
                                    <>
                                        <div className='col font-14' style={{
                                            padding: "auto",
                                            margin: "auto",
                                            fontWeight: 500,
                                            lineHeight: "24px"
                                        }}>menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} data
                                        </div>
                                        <div className='col'>
                                            <ReactPaginate
                                                previousLabel={<img src={ArrowLeft} alt=''/>}
                                                nextLabel={<img src={ArrowRight} alt=''/>}
                                                pageCount={this.state.pageCount}
                                                forcePage={this.state.currentPage}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={this.handlePageClick}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link custom-page-link'}
                                                containerClassName={'pagination my-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link custom-page-link'}
                                                previousClassName={'page-item'}
                                                previousLinkClassName={'page-link custom-prev-next-link'}
                                                nextClassName={'page-item'}
                                                nextLinkClassName={'page-link custom-prev-next-link'}
                                                activeClassName={'active custom-active'}
                                            />
                                            {/* catatan.
                                                custom classname pagination dipanggil dari file css di folder absensi harian
                                                ga hanya pagination, semua classname dari css absensi harian bisa dipanggil file ini */}
                                        </div>
                                    </>
                                    {/* // } */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(GoogleApiWrapper({
    apiKey: APIKEY
})(withTourGuide(List_outlet)));
